import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import {
  MarketingCampaign,
  UpdateMarketingCampaignPayload
} from "../../marketing.types";

export const requestUpdateMarketingCampaign = async ({
  campaignId,
  data
}: UpdateMarketingCampaignPayload): Promise<MarketingCampaign> => {
  return await instance.patch(
    `${ApiRoutesMarketing.Campaigns}/${campaignId}`,
    data
  );
};
